import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../components/api'
import Table from 'react-bootstrap/Table'

import StatusValidacaoSecao from '../components/StatusValidacaoSecao'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import Correcoes from '../components/Correcoes'
import EmailCorrecoes from '../components/EmailCorrecoes'

import { useEnunciadoContext } from '../context/enunciadoContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'



const Modal = (props) => {


    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()

    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
        
    const formulario_id = props.formulario_id


    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id

    var [totalPendencias, setTotalPendencias] = useState(0)
    var [totalEmails, setTotalEmails] = useState(0)
    var [totalCorrecoes, setTotalCorrecoes] = useState(0)


    //var [ufItems, setUFItems] = useState([])
    //var [ufItems, setUFItems] = useState(new Map())
    
    var [perfilAnual_id, setPerfilAnual_id] = useState('')
    var [hospitalarTotalGerenciada, setHospitalarTotalGerenciada] = useState('')
    var [hospitalarTotalPhs, setHospitalarTotalPhs] = useState('')
    var [hospitalarMunicipal, setHospitalarMunicipal] = useState('')
    var [hospitalarEstadual, setHospitalarEstadual] = useState('')
    var [hospitalarFederal, setHospitalarFederal] = useState('')
    var [ambulatorialTotalGerenciada, setAmbulatorialTotalGerenciada] = useState('')
    var [ambulatorialTotalPhs, setAmbulatorialTotalPhs] = useState('')
    var [ambulatorialMunicipal, setAmbulatorialMunicipal] = useState('')
    var [ambulatorialEstadual, setAmbulatorialEstadual] = useState('')
    var [ambulatorialFederal, setAmbulatorialFederal] = useState('')
    var [urgenciaTotalGerenciada, setUrgenciaTotalGerenciada] = useState('')
    var [urgenciaTotalPhs, setUrgenciaTotalPhs] = useState('')
    var [urgenciaMunicipal, setUrgenciaMunicipal] = useState('')
    var [urgenciaEstadual, setUrgenciaEstadual] = useState('')
    var [urgenciaFederal, setUrgenciaFederal] = useState('')
    var [sadtTotalGerenciada, setSadtTotalGerenciada] = useState('')
    var [sadtTotalPhs, setSadtTotalPhs] = useState('')
    var [sadtMunicipal, setSadtMunicipal] = useState('')
    var [sadtEstadual, setSadtEstadual] = useState('')
    var [sadtFederal, setSadtFederal] = useState('')
    var [colaboradores, setColaboradores] = useState('')
    var [uf, setUF] = useState('')



    const [questao1, setQuestao1] = useState()
    const [questao2, setQuestao2] = useState()
    const [questao3, setQuestao3] = useState()
    const [questao4, setQuestao4] = useState()
    const [questao5, setQuestao5] = useState()
    const [questao6, setQuestao6] = useState()
    const [questao7, setQuestao7] = useState()
    const [questao8, setQuestao8] = useState()
    const [questao9, setQuestao9] = useState()
    


    const [dataUnidadesVinculadas, setDataUnidadesVinculadas] = useState([])
    const [unidadesVinculadasperfil, setUnidadesVinculadasperfil] = useState([])


    const handleChange = (e) => {
        e.preventDefault();
    }



    const listaEmailsCorrecoes = () => {

        //console.log(`emailsCorrecoesDesafio/${formulario_id}`, 'abcd')

        api.get(`emailsCorrecoesDesafio/${formulario_id}`).then((result) => {

            //console.log(result.data, 'abcd')
            setTotalEmails(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })

    }

    function verificaVinculoExistente(adesao_institucional_id) {

        //console.log(unidadesVinculadasperfil.length, 'tamanho')
        if (unidadesVinculadasperfil.length == 0) {

            return ''

        } else {

            for (var i = 0; i < unidadesVinculadasperfil.length; i++) {

                if (unidadesVinculadasperfil[i].adesao_institucional_id == adesao_institucional_id) {
    
                    //console.log(unidadesVinculadasperfil[i].confirmado)
    
                    return (unidadesVinculadasperfil[i].confirmado)
    
                }  
    
            }

        }

        

    }



    async function carregaUnidadesVinculadasPerfil(perfilAnual_id) {

        //console.log('passou aqui...')

        if (perfilAnual_id) {

            

            await api.get(`perfilAnualCorpUnidadeListaUm/${perfilAnual_id}`).then((result) => {

                console.log(result.data)

                setUnidadesVinculadasperfil(result.data)
                
    
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })

        }

        

    }



    async function carregaUnidadesVinculadas() {

        await api.get(`unidadesVinculadas/${adesao_institucional_id}`).then((result) => {

            //console.log(result.data)

            setDataUnidadesVinculadas(result.data)

        }).catch((err) => {

            console.log(err.response)

        })


    }



    const marcaUnidadeVinculada = (nome, valor) => {

        

        if (unidadesVinculadasperfil.filter(item => item.adesao_institucional_id.toString() !== nome)) {

            setUnidadesVinculadasperfil(unidadesVinculadasperfil => unidadesVinculadasperfil.filter(item => item.adesao_institucional_id.toString() !== nome))

        }


        //if (valor != '') {

            var data = {

                adesao_institucional_id: nome,
                confirmado: valor,
    
            }
    
    
            setUnidadesVinculadasperfil(unidadesVinculadasperfil => [...unidadesVinculadasperfil, data])

        //}
        console.log(unidadesVinculadasperfil)

      }



    async function carregaPerfilAnualGestao() {

        setHospitalarTotalGerenciada('')
        setHospitalarTotalPhs('')
        setHospitalarMunicipal('')
        setHospitalarEstadual('')
        setHospitalarFederal('')
        setAmbulatorialTotalGerenciada('')
        setAmbulatorialTotalPhs('')
        setAmbulatorialMunicipal('')
        setAmbulatorialEstadual('')
        setAmbulatorialFederal('')
        setUrgenciaTotalGerenciada('')
        setUrgenciaTotalPhs('')
        setUrgenciaMunicipal('')
        setUrgenciaEstadual('')
        setUrgenciaFederal('')
        setSadtTotalGerenciada('')
        setSadtTotalPhs('')
        setSadtMunicipal('')
        setSadtEstadual('')
        setSadtFederal('')
        setColaboradores('')
        
        

        await api.get(`perfilAnualCorpListaUm/${adesao_institucional_id}/${ano}`).then((result) => {
            
            //console.log(result.data, 'aqui')

            var data = result.data[0]

            setPerfilAnual_id(data.perfilAnual_id)
            setHospitalarTotalGerenciada(data.hospitalarTotalGerenciada)
            setHospitalarTotalPhs(data.hospitalarTotalPhs)
            setHospitalarMunicipal(data.hospitalarMunicipal)
            setHospitalarEstadual(data.hospitalarEstadual)
            setHospitalarFederal(data.hospitalarFederal)
            setAmbulatorialTotalGerenciada(data.ambulatorialTotalGerenciada)
            setAmbulatorialTotalPhs(data.ambulatorialTotalPhs)
            setAmbulatorialMunicipal(data.ambulatorialMunicipal)
            setAmbulatorialEstadual(data.ambulatorialEstadual)
            setAmbulatorialFederal(data.ambulatorialFederal)
            setUrgenciaTotalGerenciada(data.urgenciaTotalGerenciada)
            setUrgenciaTotalPhs(data.urgenciaTotalPhs)
            setUrgenciaMunicipal(data.urgenciaMunicipal)
            setUrgenciaEstadual(data.urgenciaEstadual)
            setUrgenciaFederal(data.urgenciaFederal)
            setSadtTotalGerenciada(data.sadtTotalGerenciada)
            setSadtTotalPhs(data.sadtTotalPhs)
            setSadtMunicipal(data.sadtMunicipal)
            setSadtEstadual(data.sadtEstadual)
            setSadtFederal(data.sadtFederal)
            setColaboradores(data.colaboradores)
            setUF(data.uf)

            carregaUnidadesVinculadasPerfil(data.perfilAnual_id)

            

            //console.log(ufItems.indexOf('PE'))

        }).catch((err) => {

            console.log(err.response)

        })


    }


    function geraPDF() {


    }


    const verificaValidacoes = () => {

        //console.log(perfilAnual_id, 'aqq')

        setQuestao1()
        setQuestao2()
        setQuestao3()
        setQuestao4()
        setQuestao5()
        setQuestao6()
        setQuestao7()
        setQuestao8()
        setQuestao9()
        

        if (perfilAnual_id) {

            var dataPost = {

                formulario_id: perfilAnual_id,
                desafio: 'PerfilAnual',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                //console.log(result.data, 'aqui')
                var data = result.data
                var totalErros = 0

                setTotalCorrecoes(data.length)

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'Tipo da Organização':

                                setQuestao1('red')
                                totalErros = totalErros + 1
    
                            break

                            case 'Número total de colaboradores':

                                setQuestao2('red')
                                totalErros = totalErros + 1
    
                            break

                            case 'Em que estados sua organização atua?':

                                setQuestao3('red')
                                totalErros = totalErros + 1
    
                            break

                            case 'Confira as unidades vinculadas a sua organização e confirme a continuidade da gestão.':

                                setQuestao4('red')
                                totalErros = totalErros + 1
    
                            break

                        }

                    }

                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }

    useEffect(() => {

        verificaValidacoes()
        listaEmailsCorrecoes()

    }, [verificaDesafio, formulario_id, perfilAnual_id])



    useEffect(() => {

        window.$('[href="#tabPC1"]').tab('show');

        carregaPerfilAnualGestao()
        setUnidadesVinculadasperfil([])
        carregaUnidadesVinculadas()

    }, [adesao_institucional_id, ano])


    return (

        <div>


            <div className="modal fade" id="modalPerfilAnualCorp" tabindex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document"   style={{ width: '95%'}}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Perfil Anual - {ano}</h1>
                            </div>
                            <div class="modal-body">
                                
                                <div class="panel-body">


                                    <div className="col-md-12">


                                                <ul class="nav nav-tabs">
                                                        <li class="active"><a href="#tabPC1" data-toggle="tab">Perfil Anual Corporativo</a></li>
                                                        <li><a href="#tabPC2" data-toggle="tab">Correções ({totalCorrecoes})</a></li>
                                                        <li><a href="#tabPC3" data-toggle="tab">E-mails ({totalEmails})</a></li>
                                                </ul>

                                                <div class="tab-content">
                                                    <div class="tab-pane fade in active" id="tabPC1">
                                                        <div class="panel-body">




                                                            <Table striped bordered hover >
                                                    
                                                                <thead>
                                                                    <tr style={{backgroundColor: '#e6f7ec'}}>

                                                                        <th rowSpan={2}>
                                                                            <center>
                                                                            <Link style={{ color: questao1 }} onClick={() => {setEnunciado('Tipo da Organização');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                                Tipo da Organização
                                                                            </Link>

                                                                            
                                                                            </center>
                                                                        </th>
                                                                        <th rowSpan={2}>
                                                                            <center>
                                                                            Total geral de unidades Gerenciada *
                                                                            </center>
                                                                        </th>
                                                                        <th rowSpan={2}>
                                                                            <center>
                                                                            Total de unidades que são Membros do PHS *
                                                                            </center>
                                                                        </th>
                                                                        <th colSpan={3}>
                                                                            <center>
                                                                        Gestão por Organização Social de Saúde (OSS)
                                                                        </center>
                                                                        </th>
                                                                    </tr>
                                                                    <tr style={{backgroundColor: '#efefef'}}>

                                                                        <th><center>Municipal *</center></th>
                                                                        <th><center>Estadual *</center></th>
                                                                        <th><center>Federal *</center></th>

                                                                    </tr>

                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            Prestação de serviços de assistência à saúde hospitalar
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setHospitalarTotalGerenciada(event.target.value)}
                                                                            disabled={true}
                                                                            value={hospitalarTotalGerenciada}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setHospitalarTotalPhs(event.target.value)}
                                                                            disabled={true}
                                                                            value={hospitalarTotalPhs}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setHospitalarMunicipal(event.target.value)}
                                                                            disabled={true}
                                                                            value={hospitalarMunicipal}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setHospitalarEstadual(event.target.value)}
                                                                            disabled={true}
                                                                            value={hospitalarEstadual}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setHospitalarFederal(event.target.value)}
                                                                            disabled={true}
                                                                            value={hospitalarFederal}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            Prestação de serviços de assistência à saúde ambulatorial
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setAmbulatorialTotalGerenciada(event.target.value)} 
                                                                            disabled={true}
                                                                            value={ambulatorialTotalGerenciada}                                       
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setAmbulatorialTotalPhs(event.target.value)}  
                                                                            disabled={true}
                                                                            value={ambulatorialTotalPhs}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setAmbulatorialMunicipal(event.target.value)}  
                                                                            disabled={true}
                                                                            value={ambulatorialMunicipal}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setAmbulatorialEstadual(event.target.value)}  
                                                                            disabled={true}
                                                                            value={ambulatorialEstadual}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setAmbulatorialFederal(event.target.value)}  
                                                                            disabled={true}
                                                                            value={ambulatorialFederal}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            Prestação de serviços de assistência à saúde de urgência
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setUrgenciaTotalGerenciada(event.target.value)}  
                                                                            disabled={true}
                                                                            value={urgenciaTotalGerenciada}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setUrgenciaTotalPhs(event.target.value)}  
                                                                            disabled={true}
                                                                            value={urgenciaTotalPhs}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setUrgenciaMunicipal(event.target.value)}  
                                                                            disabled={true}
                                                                            value={urgenciaMunicipal}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setUrgenciaEstadual(event.target.value)} 
                                                                            disabled={true}
                                                                            value={urgenciaEstadual}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setUrgenciaFederal(event.target.value)} 
                                                                            disabled={true}
                                                                            value={urgenciaFederal}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            Prestação de serviços auxiliares à diagnose e terapia (SADT)
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setSadtTotalGerenciada(event.target.value)} 
                                                                            disabled={true}
                                                                            value={sadtTotalGerenciada}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setSadtTotalPhs(event.target.value)} 
                                                                            disabled={true}
                                                                            value={sadtTotalPhs}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setSadtMunicipal(event.target.value)} 
                                                                            disabled={true}
                                                                            value={sadtMunicipal}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setSadtEstadual(event.target.value)} 
                                                                            disabled={true}
                                                                            value={sadtEstadual}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' 
                                                                            onChange={event => setSadtFederal(event.target.value)} 
                                                                            disabled={true}
                                                                            value={sadtFederal}
                                                                            onCut={handleChange}
                                                                            onCopy={handleChange}
                                                                            onPaste={handleChange}
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>

                                                            </Table>


                                                            * Em caso negativo, preencher com zero (0)

                                                            <br/><br/>

                                                            <div className="col-md-12" >
                                                                <div class="form-group" >
                                                                    <label className="control-label"><br/>
                                                                    <Link style={{ color: questao2 }} onClick={() => {setEnunciado('Número total de colaboradores');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                        Número total de colaboradores:
                                                                    </Link>
                                                                    
                                                                    </label>
                                                                    <input className="form-control" input="text" 
                                                                    disabled={true}
                                                                    onChange={event => setColaboradores(event.target.value)}
                                                                    value={colaboradores}
                                                                    onCut={handleChange}
                                                                    onCopy={handleChange}
                                                                    onPaste={handleChange}
                                                                    onKeyPress={(event) => {
                                                                        if (!/[0-9]/.test(event.key)) {
                                                                        event.preventDefault();
                                                                        }
                                                                    }} 
                                                                    />
                                                                        
                                                                </div>
                                                            </div>


                                                            <br/><br/>

                                                            <Table striped bordered hover>
                                                                
                                                                <tbody>

                                                                    <tr>
                                                                        <th style={{backgroundColor: '#e6f7ec'}}>

                                                                            <Link style={{ color: questao3 }} onClick={() => {setEnunciado('Em que estados sua organização atua?');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                                Em que estados sua organização atua?
                                                                            </Link>
                                                                            
                                                                        </th>
                                                                    </tr>
                                                                    <tr>

                                                                        <td>
                                                                            {uf}
                                                                        </td>

                                                                    </tr>                          

                                                                </tbody>

                                                            </Table>


                                                            <br/><br/>

                                                                <div style={{ display: dataUnidadesVinculadas.length > 0 ? 'block' : 'none' }}>

                                                                    <Table striped bordered hover >
                                                                        
                                                                        <tbody>

                                                                            <tr>
                                                                                <th style={{backgroundColor: '#e6f7ec'}}>

                                                                                    <Link style={{ color: questao4 }} onClick={() => {setEnunciado('Confira as unidades vinculadas a sua organização e confirme a continuidade da gestão.');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                                        Confira as unidades vinculadas a sua organização e confirme a continuidade da gestão.
                                                                                    </Link>

                                                                                

                                                                                </th>
                                                                                <th style={{backgroundColor: '#e6f7ec'}}>
                                                                                <center>
                                                                                    Confirme a continuidade da gestão
                                                                                </center>
                                                                                
                                                                                </th>
                                                                            </tr>
                                                                            {dataUnidadesVinculadas.map((rs) =>
                                                                                <tr key={rs.adesao_institucional_id}>
                                                                                <td>
                                                                                <font color='orange'>{rs.cnpj}</font> {rs.nome_fantasia}{' '}
                                                                                <font color='green'>
                                                                                    [{rs.municipio} - {rs.uf}]
                                                                                </font>
                                                                                </td>
                                                                                <td>
                                                                                <select
                                                                                    className='form-control'
                                                                                    disabled={true}
                                                                                    name={rs.adesao_institucional_id}
                                                                                    value={verificaVinculoExistente(rs.adesao_institucional_id)}
                                                                                    onChange={(event) =>
                                                                                    marcaUnidadeVinculada(event.target.name, event.target.value)
                                                                                    
                                                                                    }
                                                                                >
                                                                                    <option value=''>[Selecione]</option>
                                                                                    <option value={true}>Sim</option>
                                                                                    <option value={false}>Não</option>
                                                                                </select>
                                                                                </td>
                                                                            </tr>
                                                                                
                                                                            )}
                                                                            

                                                                        </tbody>

                                                                    </Table>

                                                                    </div>



                                                                    <StatusValidacaoSecao desafio="PerfilAnual" secaoCampo="situacao" totalPendencias={totalPendencias} nomeDesafio="Perfil Anual" formulario_id={perfilAnual_id} secao="Perfil Anual" adesao_institucional_id={adesao_institucional_id} ano={ano} />     

                                                        </div>

                                                        


                                                    </div>
                                                    <div class="tab-pane fade in" id="tabPC2">
                                                        <div class="panel-body">
                                                            
                                                            
                                                            <Correcoes adesao_institucional_id={adesao_institucional_id} formulario_id={perfilAnual_id} ano={ano}  origem="PerfilAnual" />



                                                        </div>
                                                    </div>
                                                    <div class="tab-pane fade in" id="tabPC3">
                                                        <div class="panel-body">
                                                            

                                                            <EmailCorrecoes adesao_institucional_id={adesao_institucional_id} formulario_id={perfilAnual_id} ano={ano}  origem="PerfilAnual" />


                                                        </div>
                                                    </div>
                                                </div>

                        
                            


                                        </div>



                                </div>                                 
                            
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => geraPDF()} disabled>PDF</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>
    )


}

export default Modal